<template>
  <div>
      <!-- <el-tree :data="data" :props="defaultProps"></el-tree> -->
      <div id="TreeData">

      </div>
  </div>
</template>
<script>
import echarts from 'echarts'
import {treedata} from '../../assets/js/tree.js'
export default {
    name: "TechnologyList",
    data(){
      return{

        defaultProps: {
          children: 'children',
          label: 'label'
        },
      }
    },
    mounted(){
      this.getMap();
    },
    methods:{
      getMap(){
        let data = treedata;
        var myChart = echarts.init(document.getElementById('TreeData'));
        myChart.showLoading();
        // $.get('../asset/js/tree.json', function (data) {
          myChart.hideLoading();

          // echarts.util.each(data.children, function (datum, index) {
          //   index % 2 === 0 && (datum.collapsed = true);
          // });

          myChart.setOption({
            tooltip: {
              trigger: 'item',
              triggerOn: 'mousemove'
            },
            series: [
              {
                itemStyle: {
                    normal: {
                        borderWidth: 1,
                        borderColor: '#aaa'
                    }
                },
                type: 'tree',

                data: [data],

                top: '1%',
                left: '7%',
                bottom: '1%',
                right: '30%',

                symbolSize: 7,

                label: {
                  normal: {
                    position: 'left',
                    verticalAlign: 'middle',
                    align: 'right',
                    fontSize: 14,
                    formatter:function(type){
                      console.log(type);
                        if(type.name.match('V11') || type.name.match('V12')){
                            return '{a|' + type.name + '}'
                        }else if(type.name.match('V9') || type.name.match('V7.2') || type.name.match('V10') || type.name.match('V8.2')){
                            return '{b|' + type.name + '}'
                        }else{
                          return type.name;
                        }
                    },
                    rich: {
                        a: {
                          color: '#ccc',
                        },
                        b:{
                          color: '#4D74FF',
                        }
                     }
                  }
                },

                leaves: {
                  label: {
                    normal: {
                      position: 'right',
                      verticalAlign: 'middle',
                      align: 'left'
                    }
                  }
                },


                expandAndCollapse: true,
                animationDuration: 550,
                animationDurationUpdate: 750
              }
            ]
          });
        // });
        window.addEventListener("resize",function(){
                myChart.resize();
            });
      }
    }
}
</script>
<style>
#TreeData{
  min-height:800px;
  width:100%;
}
</style>
